import { render, staticRenderFns } from "./schoolCard.vue?vue&type=template&id=41011c3a&scoped=true&"
import script from "./schoolCard.vue?vue&type=script&lang=js&"
export * from "./schoolCard.vue?vue&type=script&lang=js&"
import style0 from "./schoolCard.vue?vue&type=style&index=0&id=41011c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41011c3a",
  null
  
)

export default component.exports